var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoiceToText1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#9E0945"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4278 82.6711C30.752 80.1776 32.7829 77.0523 34.1933 73.927C35.1636 71.7833 35.8857 69.3123 35.1184 67.0896C34.3286 64.788 32.1624 63.3551 30.3571 61.7755C26.2389 58.1537 23.7454 53.4037 23.2828 47.8864C22.8315 42.5046 24.3321 37.0099 27.48 32.666C31.0679 27.7242 36.4837 24.2942 42.5312 24.0347C47.9469 23.8091 53.5319 25.0727 57.9209 28.3109C62.3211 31.549 65.3562 36.9196 65.1757 42.4707C65.1192 44.2083 64.8936 46.115 65.4916 47.7736C65.8639 48.8229 66.6424 49.8045 67.3532 50.6168C67.8045 51.1359 68.2333 51.6887 68.7636 52.1062C69.2939 52.5236 69.5872 52.7944 70.0047 53.336C70.4221 53.8776 70.6929 54.5771 70.5688 55.2541C70.4673 55.8295 70.0949 56.3372 69.6323 56.6982C69.181 57.0593 68.6507 57.3075 68.1204 57.5444C67.8271 57.5219 67.6579 57.7588 67.6127 58.0522C67.5676 58.3455 67.6917 58.6389 67.8384 58.8871C67.9851 59.1353 68.1769 59.3723 68.2897 59.643C68.4928 60.1169 68.4815 60.6923 68.2333 61.1436C67.9851 61.5949 67.5112 61.9447 67.0035 62.0237C67.4435 61.9898 67.8948 62.317 68.0189 62.7571C68.1543 63.1971 68.0302 63.6823 67.782 64.0546C67.5337 64.4269 67.1614 64.709 66.7778 64.9346C66.3378 65.1829 66.2137 65.5778 66.2814 66.0855C66.3491 66.5932 66.5747 67.0784 66.6311 67.5974C66.7778 68.7821 66.0106 69.9442 64.9951 70.5309C63.9797 71.1176 62.7724 71.2304 61.6103 71.2078C57.887 71.1289 54.2088 69.7298 51.3317 67.3153",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0588 70.2935C54.3664 74.5132 53.0915 78.2816 51.8955 82.6706",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3721 57.8484V66.8746",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8857 60.1057V64.6188",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3984 61.2341V63.4907",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8594 61.2341V63.4907",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(22 21)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceToText1);
export default __webpack_public_path__ + "static/media/Voice_to_text_1.b06f9411f1374302d6cc2cf4f305466b.svg";
export { ForwardRef as ReactComponent };